<app-content-body style="min-height: 100vh; overflow-y: scroll; background-color:#f2f2f2; margin-bottom: 3rem;">
    <div class="jumbotron rounded-0">
        <div class="container-fluid">
            <div class="row p-5">
                <div class="col-md-4">
                    <h1 class="display-4 text-white font-weight-bold">NCache Cloud</h1>
                    <h4 class="text-white font-weight-normal mt-3">
                        NCache Cloud is available in Azure and AWS Marketplaces as Software-as-a-Service.
                    </h4>
                    <h4 class="text-white mt-4">
                        Lets Get Started ->
                    </h4>
                </div>
                <div class="col">
                    <div class="row landing-page-card-container">
                        <div class="col mb-3">
                            <div class="landing-page-card shadow d-flex flex-column justify-content-between">
                                <div class="px-4 pb-4">
                                    <h4 class="landing-page-card-title">Free Trial</h4>
                                    <h6 class="landing-page-card-subtitle mb-4">60 Day Evaluation</h6>
                                    <p class="landing-page-card-list-item">Fully working</p>
                                    <hr class="landing-page-card-hr">
                                    <p class="landing-page-card-list-item">Can extend upon request</p>
                                    <hr class="landing-page-card-hr">
                                    <p class="landing-page-card-list-item">Fully featured NCache Cloud</p>
                                    <hr class="landing-page-card-hr">
                                    <p class="landing-page-card-list-item text-red">Only pay for infrastructure</p>
                                    <hr class="landing-page-card-hr">
                                </div>
                                <div>
                                    <button (click)="goToRegistration('Free Trial')" class="btn landing-page-btn landing-page-btn-light rounded-pill w-100 font-weight-bold py-3">Try Now</button>
                                </div>
                            </div>
                        </div>
                        <div class="col mb-3">
                            <div class="landing-page-card shadow d-flex flex-column justify-content-between">
                                <div class="px-4 pb-4">
                                    <h4 class="landing-page-card-title">Purchased</h4>
                                    <h6 class="landing-page-card-subtitle mb-4">1-Year Reserved + Pay as You Go</h6>
                                    <p class="landing-page-card-list-item">Reserve baseline capacity</p>
                                    <hr class="landing-page-card-hr">
                                    <p class="landing-page-card-list-item">Increase capacity mid-year until subscription ends</p>
                                    <hr class="landing-page-card-hr">
                                    <p class="landing-page-card-list-item">Pay as You Go (hourly) for short-term capacity increase</p>
                                    <hr class="landing-page-card-hr">
                                    <p class="landing-page-card-list-item">Technical Support included</p>
                                    <hr class="landing-page-card-hr">
                                    <p class="landing-page-card-list-item">24/7 Technical Support for large subscriptions</p>
                                    <hr class="landing-page-card-hr">
                                </div>
                                <div>
                                    <button [disabled]="true" (click)="goToRegistration('Paid Subscription')" class="btn landing-page-btn landing-page-btn-dark rounded-pill w-100 font-weight-bold py-3">Purchase</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="height: 6rem; display: block;"></div>
        </div>
    </div>
    <app-sticky-footer></app-sticky-footer>
</app-content-body>